import { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import logoColourful from '../assets/logo/logo-colorful.svg'
import linkedin from '../assets/linkedin-logo.svg'
import facebook from '../assets/facebook.svg'
import twitter from '../assets/twitter.svg'
import instagram from '../assets/instagram.svg'

const Footer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Wrapper>
      <footer className="footer_section footer_wrapper_mobile">
        <div className="footer-center">
          <div className="copyright_footer_mobile_top">
            <div className="bottom_footer_logo_top">
              <img src={logoColourful} alt="logo" />
            </div>

            <div className="bottom_footer_copyrightText">
              <span>© 2021 Wecanrush Inc. All rights reserved.</span>
            </div>
          </div>
          <div className="footer_content_wrapper  sub_text">
            <div className="footer_content_1 ">
              <span className="footer_content_1_address_text">
                501 Silverside Rd, Wilmington, DE, 19809, USA
              </span>

              <div className="footer_content_1_communicate_text">
                <span>info@wecanrush.com</span>
                <span>+1 317 603 6622</span>
              </div>

              <div className="footer_content_1_social">
                <h3 className="footer_heading_text_findus ">Find us on</h3>

                <div className="social_media_wrapper">
                  <div className="social_media_icons">
                    <Link
                      onClick={() =>
                        window.open("https://www.linkedin.com/", "_blank")
                      }
                    >
                      <img
                        src={linkedin}
                        alt="linkedin"
                      />
                    </Link>

                    <Link
                      onClick={() =>
                        window.open("  https://www.facebook.com/", "_blank")
                      }
                    >
                      <img src={facebook} alt="facebook" />
                    </Link>

                    <Link
                      onClick={() =>
                        window.open("  https://www.twitter.com/", "_blank")
                      }
                    >
                      <img src={twitter} alt="twitter" />
                    </Link>

                    <Link
                      onClick={() =>
                        window.open("  https://www.instagram.com/", "_blank")
                      }
                    >
                      <img src={instagram} alt="instagram" />
                    </Link>
                  </div>
                  <div className="language">
                    <select name="cars" id="cars">
                      <option value="volvo">English(US)</option>
                    </select>
                    {/* <img
                      src="../../assets/langArrow.png"
                      alt="language select option"
                    /> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="footer_content_for_mobile">
              <div className="footer_content_2">
                <h3 className="footer_heading_text">WeCanRush</h3>
                <ul>
                  <Link to="/howitwork">
                    <li>How it Works</li>
                  </Link>

                  <Link to="/faq">
                    <li>FAQs</li>
                  </Link>
                  <Link to="/about">
                    <li>About</li>
                  </Link>
                  <Link to="/business">
                    <li>Business</li>
                  </Link>
                  <Link to="/contactus">
                    <li>Contact</li>
                  </Link>
                </ul>
              </div>

              <div className="footer_content_2">
                <h3 className="footer_heading_text">Information</h3>
                <ul>
                  <Link to="/drivers">
                    <li>Become a driver</li>
                  </Link>

                  <Link
                    onClick={() =>
                      window.open("https://www.wecanrush.com/", "_blank")
                    }
                  >
                    <li>Blog</li>
                  </Link>

                  <Link
                    onClick={() =>
                      window.open("https://wecanrush.zendesk.com/", "_blank")
                    }
                  >
                    <li>Help Center</li>
                  </Link>
                  <Link to="/individuals">
                    <li>Customer</li>
                  </Link>

                  <li>Sitemap</li>
                </ul>
              </div>

              <div className="footer_content_3">
                <h3 className="footer_heading_text">Locations</h3>
                <ul>
                  <Link to="/location">
                    <li>Indianapolis</li>
                  </Link>
                  <Link to="/location">
                    <li>Fort Wayne</li>
                  </Link>
                  <Link to="/location">
                    <li>Louisville</li>
                  </Link>
                  <Link to="/location">
                    <li>Cincinnati</li>
                  </Link>
                  <Link to="/location">
                    <li>Columbus</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>

          <div className="bottom_footer">
            {/* <div className="bootom_footer_wrapper"> */}
            <div className="bottom_footer_logo">
              <img src={logoColourful} alt="logo" />
            </div>

            <div className="bottom_footer_copyrightText">
              <span>© 2021 Wecanrush Inc. All rights reserved.</span>
            </div>

            <div className="bottom_footer_termsText">
              <ul>
                <Link to="/privacy">
                  <li>Privacy Policy </li>
                </Link>
                <Link to="/privacy">
                  <li>Terms of Service </li>
                </Link>
                <li>Careers </li>
              </ul>
            </div>
            {/* </div> */}

            <div className="languages">
              <select name="cars" id="carss">
                <option value="volvo">English(US)</option>
              </select>
              {/* <img
                      src="../../assets/langArrow.png"
                      alt="language select option"
                    /> */}
            </div>
          </div>

          {/* For only mobile  */}
          <div className="bottom_footer_termsText_mobile">
            <ul>
              <li>Privacy Policy </li>
              <li>Terms of Service </li>
              <li>Careers </li>
            </ul>
          </div>
        </div>
      </footer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  @media screen and (max-width: 414px) {
    .footer_content_2 {
      padding-right: 11% !important;
    }
  }
  @media screen and (max-width: 768px) {
    .copyright_footer_mobile_top {
      width: 100% !important;
      padding: 40px 0 0 40px !important;
      display: block !important;
    }
    .language {
      display: block !important;
      select#cars {
        outline: none;
        border: none;
        font-family: "Manrope";
        color: #6d7d93;
        font-weight: 500;
      }
    }
    .languages {
      display: none;
    }

    .copyright_mobile_top {
      display: block !important;
    }
    .footer_content_wrapper {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      flex-direction: column-reverse !important;
      width: 100%;
      padding: 40px !important;
    }
    .footer_content_for_mobile {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-flex: 1;
      -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      justify-content: space-between !important;
    }
    .footer_content_1_communicate_text {
      padding: 0px !important;
    }
    .bottom_footer_copyrightText {
      display: none !important;
    }
    .bottom_footer_logo {
      padding-right: 132px;
      display: none !important;
    }
    .bottom_footer {
      padding: 0 40px !important;
      width: 100% !important;
    }
    .bottom_footer_termsText {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: #6d7d93;
      padding-left: 0px !important;
      width: 100%;
      font-family: "Manrope";
      ul {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-direction: row;
        -ms-flex-direction: row;
        flex-direction: row;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-left: 0px !important;
        justify-content: space-between;
        width: 100%;
        li {
          padding-right: 0px;
        }
      }
    }
    .social_media_wrapper {
      display: flex;
      align-items: center;
      padding: 2px 0;
    }
    .social_media_icons {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: row;
      -ms-flex-direction: row;
      flex-direction: row;
      padding: 0px 20px 0 0 !important;
    }
  }
  .copyright_footer_mobile_top {
    display: none;
  }
  .language {
    display: none;
  }

  .languages {
    margin-left: 140px;
    margin-top: -15px;
    select#carss {
      outline: none;
      border: none;
      font-family: "Manrope";
      color: #6d7d93;
      font-weight: 500;
    }
  }
  .copyright_mobile_top {
    display: none !important;
  }
  .bottom_footer_logo_top {
    width: 130px;
    height: 35px;
  }
  .bottom_footer_termsText_mobile {
    display: none;
  }
  .footer_section {
    background: url("../../assets/wave.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
  .footer_content_wrapper {
    display: flex;
    flex-direction: row;
    padding-top: 80px;
  }
  .footer_content_1 {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  .footer_content_1 span {
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #6d7d93;
  }
  .footer_content_1_communicate_text {
    padding: 26px 0px;
  }
  .footer_content_1_communicate_text span {
    padding-right: 30px;
  }
  .footer_content_1_social {
    padding-top: 22px;
  }
  .footer_content_1_social h3 {
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    color: #6d7d93;
  }
  .social_media_icons {
    display: flex;
    flex-direction: row;
    padding-top: 17px;
  }
  .social_media_icons img {
    padding-right: 11px;
  }
  .footer_content_2 {
    padding-right: 21%;
  }
  .footer_content_2 h3 {
    font-size: 16px;
    line-height: 19px;
    color: #6d7d93;
  }
  .footer_content_2 ul {
    padding-top: 15px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 34px;
    color: #6d7d93;
    list-style: none;
    font-family: "MANROPE";
  }
  .footer_content_3 h3 {
    font-size: 16px;
    line-height: 19px;
    color: #6d7d93;
  }
  .footer_content_3 ul {
    padding-top: 15px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 34px;
    color: #6d7d93;
    list-style: none;
  }
  .bottom_footer {
    display: flex;
    flex-direction: row !important;
    align-items: center !important;
  }

  .bottom_footer_logo {
    margin-right: 117px;
    width: 130px;
    height: 35px;
  }

  .bottom_footer_copyrightText {
    font-family: Manrope;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #6d7d93;
    letter-spacing: 0.5px;
    margin-left: -40px;
  }
  .bottom_footer_termsText {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #6d7d93;
    padding-left: 11.8%;
    margin-top: 9px;
    font-family: "Manrope";
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: -40px;
    }
    li {
      padding-right: 20px;
    }
    a {
      color: #6d7d93;
    }
  }

  .bottom_footer {
    padding-top: 5%;
    padding-bottom: 23px;
  }
  .footer_content_for_mobile {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
  }

  .footer_content_2 a {
    text-decoration: none;
    color: #6d7d93;
  }

  .footer_content_3 a {
    color: #6d7d93;
  }
`;

export default Footer;
